import { ElementType, FC, ReactNode } from 'react';

import { cn } from '@/utils/tailwind';

import { Card, IconBox } from '../../atoms';
import { CardContent } from '../../atoms/Card/Card';

type PickerCardProps = {
  label: ReactNode;
  icon?: ElementType;
  isSelected?: boolean;
  className?: string;
  onClick: () => void;
};

export const PickerCard: FC<PickerCardProps> = ({
  label,
  icon: Icon,
  isSelected,
  className,
  onClick,
}) => {
  return (
    <Card
      className={cn(
        'rounded-[12px] group cursor-pointer bg-custom-warm-grey-25 transition-colors select-none',
        Icon ? 'p-2.5' : 'px-3 py-2',
        isSelected ? 'bg-custom-cyan-25 !border-custom-cyan-400' : 'hover:bg-custom-warm-grey-100',
        className
      )}
      onClick={onClick}
    >
      <CardContent className="flex items-center gap-3">
        {Icon && (
          <IconBox
            icon={Icon}
            className={cn(
              'transition-colors',
              isSelected ? '!bg-custom-cyan-100 text-custom-cyan-500' : 'bg-custom-warm-grey-100'
            )}
          />
        )}
        <div>
          <div
            className={cn(
              'text-body-16-medium',
              isSelected ? '!text-custom-cyan-600' : '!text-custom-warm-grey-700'
            )}
          >
            {label}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
